import { takeLatest, put, call } from 'redux-saga/effects';

import { listImplantacaoEstoqueProducao } from '../service';
import {
  TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO,
  TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO_PENDING,
  TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO_SUCCESS,
  TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO_FAILURE
} from '../actionTypes';

function* sagaListImplantacaoEstoqueProducao(action) {
  yield put({ type: TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO_PENDING })

  try {
    const table = yield call(listImplantacaoEstoqueProducao, action.args)
    yield put({ type: TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListImplantacaoEstoqueProducao() {
  yield takeLatest(TABLE_IMPLANTACAO_ESTOQUE_PRODUCAO, sagaListImplantacaoEstoqueProducao)
}